import { Alert, Toolbar } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledRoot = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1, 0, 3),
}));

export default function RolesToolbar() {
  return (
    <StyledRoot>
      <Alert severity="info" sx={{ width: '100%' }}>
        Only 3 roles are available: Organization Admin, Brand Admin, and Support Agent.
      </Alert>
    </StyledRoot>
  );
}
